/**
 * StakeCurrencyContainer defines Stake currency container
 *
 * @typedef StakeCurrencyContainer
 * @type {Object}
 * @property {defaultStake}  the default stake of the currency
 * @property {isDefault} is the default currency
 * @property {id} ID of the currency
 * @property {pulseBettingStakeValuesSeries} Array of stake series numbers
 */
var StakeCurrencyContainer = /** @class */ (function () {
    function StakeCurrencyContainer(source) {
        this.defaultStake = source.defaultStake;
        this.isDefault = source.isDefault;
        this.pulseBettingStakeValuesSeries = source.pulseBettingStakeValuesSeries;
        this.id = source.id;
    }
    return StakeCurrencyContainer;
}());
export { StakeCurrencyContainer };
//# sourceMappingURL=StakeCurrencyContainer.js.map